export enum EBillingPlanSelectionSteps {
  planSelection = 'planSelection',
  changeTenantInfo = 'changeTenantInfo',
  completeConnection = 'completeConnection',
}
